import * as React from 'react';
import TopLeftCompareProduct from './TopLeftCompareProduct/TopLeftCompareProduct';
import TopRightCompareProduct from './TopRightCompareProduct/TopRightCompareProduct';

const TopCompareProduct = (props) => {

    return (
        <>
            <div className="table-area-actions d-flex justify-content-between align-items-center">

                <TopLeftCompareProduct />

                <TopRightCompareProduct />

            </div>
        </>
    );
}

export default TopCompareProduct;